import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'

const state = {
  ...restful.states('lcsw_account'),
  provinces: [],
  cities: [],
  counties: [],
  net_banks: [],
  industries: []
}

const getters = {
  ...restful.getters('lcsw_account'),
  provinces: (state) => state.provinces,
  cities: (state) => state.cities,
  counties: (state) => state.counties,
  industries: (state) => state.industries,
  net_banks: (state) => state.net_banks
}

const actions = {
  ...restful.actions('lcsw_accounts'),
  async find_one ({ commit }) {
    const res = await axios.get('lcsw_accounts/find_one')
    commit('lcsw_account', res.data)
    return res
  },
  async grant ({ commit }, params) {
    const res = await axios.post('lcsw_accounts/grant', params)
    commit('lcsw_account', res.data)
  },
  async province_index ({ commit }) {
    const res = await axios.get('lcsw_accounts/provinces')
    commit('provinces', res)
  },
  async set_record ({ commit }, params) {
    commit('setRecord', params)
  },
  async cities_index ({ commit }, province_code) {
    const res = await axios.get(
      `lcsw_accounts/cities?province_code=${province_code}`
    )
    commit('cities', res)
  },
  async counties_index ({ commit }, city_code) {
    const res = await axios.get(
      `lcsw_accounts/districts?city_code=${city_code}`
    )
    commit('counties', res)
  },
  async industries_index ({ commit }) {
    const res = await axios.get('lcsw_accounts/industries')
    commit('industries', res)
  },
  async net_banks_index ({ commit }, keyword) {
    const res = await axios.get(`lcsw_accounts/net_banks?keyword=${keyword}`)
    commit('net_banks', res)
  }
}

const mutations = {
  ...restful.mutations('lcsw_account'),
  lcsw_account (state, lcsw_account) {
    state.lcsw_account = lcsw_account
  },
  provinces (state, provinces) {
    state.provinces = provinces
  },
  cities (state, cities) {
    state.cities = cities
  },
  counties (state, counties) {
    state.counties = counties
  },
  net_banks (state, net_banks) {
    state.net_banks = net_banks
  },
  industries (state, industries) {
    state.industries = industries
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
